// extracted by css-extract-rspack-plugin
export default {"root":"Ec0h8","dot":"avvNB"};